import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
    const [headerColor, setHeaderColor] = useState('#ff0000');
    const [fontColor, setFontColor] = useState('light');
    const [logoUrl, setLogoUrl] = useState('');

    useEffect(() => {
        console.log('loaded')
        const loadSettings = async () => {
            try {
                const response = await fetch('https://marzdev.yourcrm.co.za/api/get_settings');
                if (!response.ok) {
                    console.error(`HTTP error! Status: ${response.status}`);
                    alert(`Failed to fetch settings: ${response.statusText}`);
                    return;
                }
                const settings = await response.json();
                settings.forEach(setting => {
                    if (setting.SettingName === 'headerColor') setHeaderColor(setting.SettingValue);
                    if (setting.SettingName === 'fontColor') setFontColor(setting.SettingValue);
                    if (setting.SettingName === 'logoUrl') setLogoUrl(setting.SettingValue);
                });
                console.log('try complete')
            } catch (error) {
                console.error('Error fetching data:', error);
                alert('An error occurred while fetching settings data. Please try again later.');
            }
        };
        loadSettings();
    }, []);

    return (
        <div className="home-container">
            <div className="tile-grid">
                <Link to="/activities" className="tile large">
                    <img src="https://t3.ftcdn.net/jpg/10/89/19/46/360_F_1089194606_6af9E8Z8Q6nQd8hbbJl8YdrzoYhsQz1F.jpg" alt="Activities List" className="tile-image" />
                    <div className="tile-content">
                        <h2>Activities List</h2>
                        <p>Manage activities here.</p>
                    </div>
                </Link>
                <Link to="/care-recipients" className="tile high">
                    <img src="https://media.gettyimages.com/id/1440007654/photo/senior-at-a-health-check-up.jpg?s=612x612&w=gi&k=20&c=5NRPYg3WUf4GpN__malZgRPPS9zI5yAuAQ6UXMsreqA=" alt="Customer Management" className="tile-image" />
                    <div className="tile-content">
                        <h2>Care Recipient Management</h2>
                        <p>Manage care recipients here.</p>
                    </div>
                </Link>
                <Link to="/priceList" className="tile">
                    <img src="https://media.istockphoto.com/id/1333684872/photo/multipurpose-room-for-long-term-care-facility.jpg?s=612x612&w=0&k=20&c=Qqn7z0VP-4mshbGqBt4SWTagY6vq0utDRYYQwtFBqMY=" alt="Price List Items" className="tile-image" />
                    <div className="tile-content">
                        <h2>Price List Items</h2>
                        <p>Manage price list items here.</p>
                    </div>
                </Link>
                <Link to="/staff-demand-report" className="tile">
                    <img src="https://media.istockphoto.com/id/1387152896/photo/female-doctor-teaching-nursing-students.jpg?s=612x612&w=0&k=20&c=88NDwtiUscz1bqG5mzPgKExmdJ7PaT9jfTj7j4ypJDU=" alt="Staff Demand Report" className="tile-image" />
                    <div className="tile-content">
                        <h2>Staff Demand Report</h2>
                        <p>View staff demand reports here.</p>
                    </div>
                </Link>
                <Link to="/settings" className="tile">
                    <img src="https://images.pexels.com/photos/567890/pexels-photo-567890.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="Settings" className="tile-image" />
                    <div className="tile-content">
                        <h2>Settings</h2>
                        <p>View general settings here.</p>
                    </div>
                </Link>
            </div>
        </div>
    );
}

export default Home;
